import {EVENT_BADGE} from '../../../../settings-commons/components/event-badges/interfaces'

export enum EVENT_BADGE_TYPE {
  FIRST_PRIORITY = 4,
  SECOND_PRIORITY = 5,
  THIRD_PRIORITY = 6,
}

export type BadgeType = EVENT_BADGE_TYPE | wix.events.BadgeType.Type

export const DEMO_EVENT_BADGES: Record<EVENT_BADGE, wix.events.Badge> = {
  [EVENT_BADGE.FIRST_PRIORITY]: {
    type: EVENT_BADGE_TYPE.FIRST_PRIORITY as unknown as wix.events.BadgeType.Type,
  },
  [EVENT_BADGE.SECOND_PRIORITY]: {
    type: EVENT_BADGE_TYPE.SECOND_PRIORITY as unknown as wix.events.BadgeType.Type,
  },
  [EVENT_BADGE.THIRD_PRIORITY]: {
    type: EVENT_BADGE_TYPE.THIRD_PRIORITY as unknown as wix.events.BadgeType.Type,
  },
}
